import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { DashboardRequestParameters } from '@portal/app/shared/types';

@Injectable({
  providedIn: 'root'
})
export class ViewStore {
  public selectedBCPDId = new BehaviorSubject<DashboardRequestParameters>({
    clientId: 0,
    brandId: 0,
    literalId: '',
    productId: ''
  });

  /**
   * Canonical dashboard literal_id for the active page; set by each page host in
   * ngOnInit and cleared in ngOnDestroy (empty = no dashboard active). Source of
   * truth for MiaContextService — prefer this over URL parsing (route data / DB
   * catalog, not URL segment heuristics).
   */
  readonly currentDashboardLiteralId = signal<string>('');

  setCurrentDashboardLiteralId(literalId: string): void {
    this.currentDashboardLiteralId.set(literalId);
  }

  private readonly titleSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>('');

  get title(): Observable<string> {
    return this.titleSubject.asObservable();
  }

  changeTitle(value: string): Observable<string> {
    const obs = new Observable((subscriber: Subscriber<string>) => {
      subscriber.next(value);
      subscriber.complete();
    });

    obs.subscribe({
      next: () => this.titleSubject.next(value)
    });

    return obs;
  }

  setBrandClientProductDashboardId(data: DashboardRequestParameters): void {
    this.selectedBCPDId.next(data);
  }
}
